"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTheme = exports.isValidThemeKey = exports.ThemeKeys = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const Util_1 = require("./Util");
// these values exist in `@kyruus/ui-theme` with appropriate fallbacks
exports.ThemeKeys = ui_theme_1.SEARCH_WIDGET_V2_THEME_KEYS;
const isValidThemeKey = (string) => {
    return exports.ThemeKeys.includes(string);
};
exports.isValidThemeKey = isValidThemeKey;
const isTheme = (dict) => exports.ThemeKeys.every((themeKey) => dict[themeKey] && ((0, Util_1.isString)(dict[themeKey]) || (0, Util_1.isNumber)(dict[themeKey])));
exports.isTheme = isTheme;
//# sourceMappingURL=Theme.js.map